import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Competition from './pages/Competition';
import DonorStats from './pages/DonorStats';
import PrivateRoute from "./auth/PrivateRoute";
import CreatedUserTrends from './pages/CreatedUserTrends'
import WeeklyUniqueUserTrends from './pages/WeeklyUniqueUserTrends'
import CountryTrendsDashboard from './pages/CountryTrendsDashboard'
import ClaraFeedbackBreakdown from './pages/ClaraFeedbackBreakdown'
import ClaraFeedbackTrends from './pages/ClaraFeedbackTrends'
import EngagementByType from './pages/EngagementByType'
import { ENV_TYPE_TEST, ENV_TYPE_PROD, ENV_TYPE_DEV } from './constants'
import NewUserReferralTrends from './pages/NewUserReferralTrends'
import TotalLoginsByDayAndHour from './pages/TotalLoginsByDayAndHour'
import PercentageEngagement from './pages/PercentageEngagement'
import ClaraUsage from './pages/ClaraUsage'
import EducatorDomains from './pages/EducatorDomains'
import DemographicsDashboard from './pages/DemographicsDashboard'
import ClaraCategorizationIframeTest from './pages/ClaraCategorizationIframTest'
import ProtectedRoute from './auth/ProtectedRoute'
import usePageTitle from './hooks/usePageTitle'

function App() {
  usePageTitle();

  return (
    <Routes>
      <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      
      <Route path="/competition" element={<PrivateRoute><Competition /></PrivateRoute>} />
      <Route path="/donor-stats" element={<PrivateRoute><DonorStats /></PrivateRoute>} />
      <Route path="/created-user-trends" element={<PrivateRoute><CreatedUserTrends /></PrivateRoute>} />
      <Route path="/weekly-unique-user-trends" element={<PrivateRoute><WeeklyUniqueUserTrends /></PrivateRoute>} />
      <Route path="/country-trends" element={<PrivateRoute><CountryTrendsDashboard /></PrivateRoute>} />
      <Route path="/clara-feedback" element={<PrivateRoute><ClaraFeedbackBreakdown /></PrivateRoute>} />
      <Route path="/clara-feedback-trends" element={<PrivateRoute><ClaraFeedbackTrends /></PrivateRoute>} />
      <Route path="/engagement-by-type" element={<PrivateRoute><EngagementByType /></PrivateRoute>} />
      <Route path="/new-user-referral-trends" element={<PrivateRoute><NewUserReferralTrends /></PrivateRoute>} />
      <Route path="/total-logins-by-day-and-hour" element={<PrivateRoute><TotalLoginsByDayAndHour /></PrivateRoute>} />
      <Route path="/percentage-engagement" element={<PrivateRoute><PercentageEngagement /></PrivateRoute>} />
      <Route path="/clara-usage" element={<PrivateRoute><ClaraUsage /></PrivateRoute>} />
      <Route path="/educator-domains" element={<PrivateRoute><EducatorDomains /></PrivateRoute>} />
      <Route path="/demographics-dashboard" element={<PrivateRoute><DemographicsDashboard /></PrivateRoute>} />
      <Route path="/clara-categorization-iframe-test" element={<PrivateRoute><ClaraCategorizationIframeTest /></PrivateRoute>} />
      {/* Iframe routes */}
      <Route path="/iframe/competition" element={<Competition />} />

      <Route path="/iframe/clara-feedback" element={<ProtectedRoute><ClaraFeedbackBreakdown envType={ENV_TYPE_PROD} /></ProtectedRoute>} />
      <Route path="/iframe/clara-feedback-dev" element={<ProtectedRoute><ClaraFeedbackBreakdown envType={ENV_TYPE_DEV} /></ProtectedRoute>} />
      <Route path="/iframe/clara-feedback-test" element={<ProtectedRoute><ClaraFeedbackBreakdown envType={ENV_TYPE_TEST} /></ProtectedRoute>} />
      <Route path="/iframe/clara-feedback-trends" element={<ProtectedRoute><ClaraFeedbackTrends envType={ENV_TYPE_PROD} /></ProtectedRoute>} />
      <Route path="/iframe/clara-feedback-trends-dev" element={<ProtectedRoute><ClaraFeedbackTrends envType={ENV_TYPE_DEV} /></ProtectedRoute>} />
      <Route path="/iframe/clara-feedback-trends-test" element={<ProtectedRoute><ClaraFeedbackTrends envType={ENV_TYPE_TEST} /></ProtectedRoute>} />
    </Routes>
  );
}

export default App;
